'use client';

import dynamic from 'next/dynamic';
import React from 'react';

// Dynamically import components with ssr: false
const ClientToaster = dynamic(() => import('@/components/ui/client-toaster'), { ssr: false });
const AnalyticsProvider = dynamic(() => import('@/hooks/use-analytics').then(mod => mod.AnalyticsProvider), { ssr: false });
const CookieConsent = dynamic(() => import('@/components/shared/cookie-consent'), { ssr: false });

// This wrapper component renders the providers/components that need ssr: false
export default function ClientLayoutWrapper({ children }: { children: React.ReactNode }) {
  return (
    <AnalyticsProvider>
      {children}
      <ClientToaster />
      <CookieConsent />
    </AnalyticsProvider>
  );
} 